import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '.';

// eslint-disable-next-line import/prefer-default-export
export const selectAuth = createSelector(
  (state: RootState) => state,
  (state) => state.auth
);
